// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MCRow_label__coLaA {
  padding: 4px;
}

.MCRow_end__708hN {
  color: black;
  flex: 1 1;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.MCRow_button__MYRwZ {
  color: white;
  background-color: #7b7b7b;
  width: 2rem;
  border-radius: 3px;
}`, "",{"version":3,"sources":["webpack://./src/components/NodeInfo/MCRow.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;AACF;;AAEA;EACE,YAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;AACF","sourcesContent":[".label {\n  padding: 4px;\n}\n\n.end {\n  color: black;\n  flex: 1;\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n}\n\n.button {\n  color: white;\n  background-color: #7b7b7b;\n  width: 2rem;\n  border-radius: 3px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `MCRow_label__coLaA`,
	"end": `MCRow_end__708hN`,
	"button": `MCRow_button__MYRwZ`
};
export default ___CSS_LOADER_EXPORT___;
